import { getTypedAncestorTracker } from '../utils/helper'

export default {
  computed: getTypedAncestorTracker('select').computed
}
